import { gql } from "graphql-request";

export const ADMIN_CREATE_EXPERIMENT = gql`
  mutation AdminCreateExperiment($input: CreateExperimentInput!) {
    adminCreateExperiment(input: $input) {
      success
      message
    }
  }
`;

export const ADMIN_UPDATE_EXPERIMENT = gql`
  mutation AdminUpdateExperiment($input: UpdateExperimentInput!) {
    adminUpdateExperiment(input: $input) {
      success
      message
    }
  }
`;

export const ADMIN_UPDATE_EXPERIMENT_ROLLOUT = gql`
  mutation AdminUpdateExperimentRollout(
    $input: UpdateExperimentRolloutInput!
  ) {
    adminUpdateExperimentRollout(input: $input) {
      success
      message
    }
  }
`;

export const ADMIN_DELETE_EXPERIMENT = gql`
  mutation AdminDeleteExperiment($key: String!) {
    adminDeleteExperiment(key: $key) {
      success
      message
    }
  }
`;

export const ADMIN_UPDATE_EXPERIMENT_STATUS = gql`
  mutation AdminUpdateExperimentStatus(
    $key: String!
    $status: ExperimentStatus!
  ) {
    adminUpdateExperimentStatus(key: $key, status: $status) {
      success
      message
    }
  }
`;
